import { TwoSidedBarsChart } from '@euler/lib/charts/TwoSidedBarsChart';
import { formatBiAxisTick, formatBiShortLabel } from '@euler/model/bi/format';
import { memo, useMemo } from 'react';
import { BiChartModel } from '../functions/biChartModel';
import { BiVizLook, kBiBarGapShares } from '../functions/biVizLook';
import { useBiChartTheme } from './useBiChartTheme';

type Pyramid = Extract<BiChartModel, { kind: 'pyramid' }>;

/**
 * A pyramid: the first series to the left, the second to the right. Labels
 * read in full, or short (the unit captioned) where full ones would squeeze
 * the bars.
 */
export const BiPyramidChart = memo(
  ({
    model,
    look,
    width,
  }: {
    model: Pyramid;
    look: BiVizLook;
    width: number;
  }) => {
    const theme = useBiChartTheme();
    const [left, right] = model.series;
    const bar = useMemo(
      () => ({
        cornerRadius: look.bar.cornerRadius,
        gap: kBiBarGapShares[look.bar.gap],
      }),
      [look.bar],
    );
    if (!left) return null;
    return (
      <TwoSidedBarsChart
        width={width}
        categories={model.categories}
        left={left}
        right={right}
        dataLabels={look.dataLabels}
        bar={bar}
        format={formatBiAxisTick}
        compact={model.units.left ? formatBiShortLabel : undefined}
        theme={theme}
      />
    );
  },
);
